import {logDebugInfo} from '../ui_utils/Utils.ts'

export class ClientSocketMessageLoadTest {
    static expectedSocketAmount: number = 0
    static receivedSocketAmount: number = 0
    static startingTime: number = 0

    static processSocketData(data: any) {
        if(typeof data == 'number') {
            this.expectedSocketAmount = Number(data)
            this.receivedSocketAmount = 0
            this.startingTime = Date.now()
            logDebugInfo('processSocketData', ['-------------------------------------'])
            logDebugInfo('processSocketData', [`Expecting ${this.expectedSocketAmount}`])
        }

        if(typeof data == 'string' && data == 'test') this.receivedSocketAmount += 1

        if(typeof data == 'string' && data == 'done') {
            /* eslint-disable no-console */
            logDebugInfo('processSocketData', [`Expected ${this.expectedSocketAmount}`])
            logDebugInfo('processSocketData', [`Received ${this.receivedSocketAmount}`])
            logDebugInfo('processSocketData', [`Took ${Date.now() - this.startingTime}ms`])
            /* eslint-enable no-console */
            this.expectedSocketAmount = 0
            this.receivedSocketAmount = 0
            this.startingTime = 0
        }
    }
}
